import { ICostSummaryItem, ILineItem } from '../../CartContext.types';
import { ICustomerAppreciationDiscount } from '../../../../types/Plan';
import { useCalculateDiscountHook } from '../../../../pages/Cart/Hooks/CalculateDiscountHook';

export const useAutopayDiscountHook = (
    lineItem: ILineItem,
    discount?: ICustomerAppreciationDiscount
): ICostSummaryItem | undefined => {
    // Autopay discount only applies for lines 1 & 2 and not for special customer appreciation discount plans
    if (
        lineItem.lineNumber <= 2 &&
        lineItem.planSelection?.plan.autopayDiscount.hasDiscount &&
        (!discount || !discount?.exclusiveDiscount)
    ) {
        const amount = Number(
            useCalculateDiscountHook(
                lineItem.planSelection?.linePrice,
                lineItem.planSelection?.plan.autopayDiscount.discountType,
                lineItem.planSelection?.plan.autopayDiscount.discountAmount
            )
        );

        return {
            lineNumber: lineItem.lineNumber,
            itemName: 'Autopay Discount',
            amount: amount,
            type: 'discount'
        };
    }
};
